export default __webpack_public_path__ + "static/media/AppStore.8945593b.svg";